import axios from "axios";

let isRegistered = false;

export const setupInterceptors = ({
  getAuthToken,
  handlers = {},
}) => {
  if (isRegistered) return;
  isRegistered = true;

  const {
    onPremiumRequired,
    onUnauthorized,
    onLoginFailed,
    onRequestCanceled,
    onRequestStart,
    onRequestEnd,
  } = handlers;

  // ----------------------------
  // REQUEST INTERCEPTOR
  // ----------------------------
  axios.interceptors.request.use(
    (config) => {
      onRequestStart?.();

      const token = getAuthToken?.();
      if (token && !config?.url?.includes("people.googleapis.com")) {
        config.headers.Authorization = token;
      }

      return config;
    },
    (error) => {
      onRequestEnd?.();
      return Promise.reject(error);
    }
  );

  // ----------------------------
  // RESPONSE INTERCEPTOR
  // ----------------------------
  axios.interceptors.response.use(
    (response) => {
      onRequestEnd?.();

      const newToken = response.headers?.authorization;
      if (newToken) {
        sessionStorage.setItem("JWAUTH", newToken);
      }

      return response;
    },
    (error) => {
      onRequestEnd?.();

      const status = error?.response?.status;
      let errorDetails = error?.response?.data;
      const feature = error?.response?.data?.feature;

      if(errorDetails instanceof ArrayBuffer) {
        const blob = new Blob([errorDetails], { type: 'application/octet-stream'})
        return blob.text().then(e => { errorDetails = e;
          error.response.data.message = e;
          return Promise.reject(error);
        });
      }

      // 🔹 Request canceled
      if (error.code === "ERR_CANCELED" || error.name === "CanceledError") {
        onRequestCanceled?.();
        return Promise.reject(error);
      }



      // 🔹 Unauthorized
      if (status === 401) {
        onUnauthorized?.();
        return Promise.reject(error);
      }

      // 🔹 Login failure
      if (error?.config?.url?.includes("login")) {
        onLoginFailed?.();
        return Promise.reject(error);
      }

      // 🔹 Premium required
      if (status === 403 && !error.config?.skipPremiumInterceptor) {
        onPremiumRequired?.(feature, error.config.url);
        return Promise.reject(error);
      }

      return Promise.reject(error);
    }
  );
};